import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import ListeAnnonces from './pages/ListeAnnonces';
import './index.css';

// Pages chargées en lazy pour les performances
const DetailAnnonce  = React.lazy(() => import('./pages/DetailAnnonce'));
const NouvelleAnnonce = React.lazy(() => import('./pages/NouvelleAnnonce'));
const Connexion      = React.lazy(() => import('./pages/Connexion'));
const Inscription    = React.lazy(() => import('./pages/Inscription'));
const MesAnnonces    = React.lazy(() => import('./pages/MesAnnonces'));
const Messages       = React.lazy(() => import('./pages/Messages'));
const Favoris        = React.lazy(() => import('./pages/Favoris'));

// Route protégée
const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="loader"><div className="loader-spin" /></div>;
  return user ? children : <Navigate to="/connexion" replace />;
};

function AppContent() {
  return (
    <BrowserRouter>
      <Navbar />
      <React.Suspense fallback={<div className="loader"><div className="loader-spin" /></div>}>
        <Routes>
          <Route path="/"                  element={<HomePage />} />
          <Route path="/annonces"          element={<ListeAnnonces />} />
          <Route path="/annonces/:id"      element={<DetailAnnonce />} />
          <Route path="/connexion"         element={<Connexion />} />
          <Route path="/inscription"       element={<Inscription />} />

          {/* Routes protégées */}
          <Route path="/annonces/nouveau"  element={<PrivateRoute><NouvelleAnnonce /></PrivateRoute>} />
          <Route path="/mes-annonces"      element={<PrivateRoute><MesAnnonces /></PrivateRoute>} />
          <Route path="/messages"          element={<PrivateRoute><Messages /></PrivateRoute>} />
          <Route path="/messages/:id"      element={<PrivateRoute><Messages /></PrivateRoute>} />
          <Route path="/favoris"           element={<PrivateRoute><Favoris /></PrivateRoute>} />

          {/* 404 */}
          <Route path="*" element={
            <div style={{ textAlign: 'center', padding: '80px 20px' }}>
              <p style={{ fontSize: '4rem' }}>🏝️</p>
              <h2 style={{ fontFamily: 'var(--font-display)', fontSize: '1.5rem', margin: '16px 0 8px' }}>
                Page introuvable
              </h2>
              <a href="/" className="btn btn-primary" style={{ display: 'inline-flex', marginTop: 16 }}>
                Retour à l'accueil
              </a>
            </div>
          } />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}
